import script from "./PagesCover.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesCover.vue?vue&type=script&setup=true&lang=js"

import "./PagesCover.vue?vue&type=style&index=0&id=e80ce99a&lang=scss"

const __exports__ = script;

export default __exports__